import React, { useState, useEffect } from 'react';
import EnrolmentFormHeader from './header';
import EnrolmentFormBreadcrumb from './breadcrumb';
import EnrolmentFormPersonalData from './personaldata';
import EnrolmentFormMedicalData from './medicaldata';
import EnrolmentFormEmploymentData from './employmentdata';
import EnrolmentFormStudies from './studies';
import EnrolmentFormAuthorizations from './authorizations';
import axios from 'axios';
import { v4 as uuidv4 } from "uuid"
import { decode } from 'base-64'
import config from '../../config'
import ModalPopup from '../modal'
import { enguanyAnyVinent  } from '../utils';

const uuid = uuidv4()

export default function EnrolmentForm() {
  
  const { enguany , anyVinent } = enguanyAnyVinent()

  const [dadesPersonals, setDadesPersonals] = useState({'validat': false})
  const [dadesMediques, setDadesMediques] = useState({'validat': false})
  const [dadesLaborals, setDadesLaborals] = useState({'validat': false})
  const [dadesEstudis, setDadesEstudis] = useState({'validat': false})
  const [dadesAutoritzacions, setDadesAutoritzacions] = useState({'validat': false})

  const [inscripcio, setInscripcio] = useState();
  const [sending, setSending] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [families, setFamilies] = useState([]);

  const apartatsOmesos = dadesPersonals.apartatsOmesos || []
  const saltaDadesMediques = apartatsOmesos.includes('mediques')
  const saltaDadesLaborals = apartatsOmesos.includes('laborals') || dadesPersonals.edat < 16


  useEffect((e) => {
    fetch(config.apiURL,{ method:'POST', 
      body: JSON.stringify({ cid: config.cid, act: 'getFam' }),
      headers: new Headers({'Content-Type': 'application/json' })})
      .then(res => res.json())
      .then(data => setFamilies(JSON.parse(decode(data.f))))
      .catch((err) => { console.log(err) })
    },[])


  useEffect(() => {
    // Automatically open modal on mount
    setIsModalOpen(true);
  }, []);


  useEffect(() => {
    if (!dadesPersonals.validat) return
    if (saltaDadesMediques && !dadesMediques.validat) setDadesMediques({ validat: true })
    if (saltaDadesLaborals && !dadesLaborals.validat) setDadesLaborals({ validat: true })
  }, [dadesPersonals.validat, saltaDadesMediques, saltaDadesLaborals])


  // redirecció automàtica a la passarel·la de pagament (Art La Industrial, només alumnes de
  // monogràfics): un cop feta la inscripció i si hi ha import a pagar, s'hi va directament
  // sense mostrar cap pantalla intermèdia (número d'inscripció, contacte amb secretaria,
  // enllaç al TPV...). La resta d'estudis mantenen el funcionament de sempre.
  const redirigirTPV = config.redireccioAutomaticaTPV === true && config.pagamentTPV === true
    && inscripcio?.response === "ok"
    && dadesEstudis?.curs?.id?.startsWith("MONO")
    && dadesEstudis?.quota?.total > 0

  useEffect(() => {
    if (redirigirTPV) {
      window.location.href = config.urlTPV + "?uuid=" + uuid + "&iddocument=" + (dadesPersonals?.iddocument ?? "")
    }
  }, [redirigirTPV, dadesPersonals])


  const submitForm = (e) => {
    e.preventDefault();

    // Guard: no permetem enviar si algun pas no està validat.
    // (Evita enviaments accidentals/manipulats des del client; cal
    // complementar-ho amb validació al servidor, que és l'autoritativa.)
    if(!dadesPersonals.validat ||
       !dadesMediques.validat ||
       !dadesLaborals.validat ||
       !dadesEstudis.validat ||
       !dadesAutoritzacions.validat)
    {
      console.log('submitForm bloquejat: falten passos per validar', {
        dadesPersonals: dadesPersonals.validat,
        dadesMediques: dadesMediques.validat,
        dadesLaborals: dadesLaborals.validat,
        dadesEstudis: dadesEstudis.validat,
        dadesAutoritzacions: dadesAutoritzacions.validat,
      })
      return false
    }

    const dadesPost = {
      cid: config.cid,
      uuid: uuid,
      dadesPersonals,
      dadesMediques,
      dadesLaborals,
      dadesEstudis,
      dadesAutoritzacions,
    }

    if(!sending)
    {
      setSending(true)

      console.log('SENDING!',uuid, dadesPost)

      const headers = { 'Content-Type': 'multipart/form-data' }

      axios.post(config.enrollmentPostURL, dadesPost, headers)
        .then(response => setInscripcio(response.data))
        .catch((err) => { 
          console.log(err)
          setInscripcio({response: "ko", error: err})
          setSending(false) // si hi ha error donem l'oportunitat de tornar a enviar ??
        });
    }

    return false;
  }
  
  const handleChangeDadesPersonals = (d) => {
    //console.log('handleChangeDadesPersonals1',d)
    //console.log('handleChangeDadesPersonals2',dadesPersonals)
    setDadesPersonals(d)
    //console.log('handleChangeDadesPersonals3',dadesPersonals)
  }
  
  const handleChangeDadesMediques= (d) => {
    setDadesMediques(d)
  }
  
  const handleChangeDadesLaborals = (d) => {
    setDadesLaborals(d)
  }
  
  const handleChangeDadesEstudis = (d) => {
    setDadesEstudis(d)
    //console.log('d1',dadesEstudis)
    //console.log('d2',d)
  }
  
  const handleChangeDadesAutoritzacions = (d) => {
    setDadesAutoritzacions(d)
  }


  const BotoInscriure = (props) => {

    return (<div className="container">
      <div className="row">
        <div className="col col-12 submitButtonDiv" align="center">
          { props.showText && (<>Fent click al següent botó formalitzareu la matrícula:<br /></>) }
          <button className="submitButton" disabled={props.sending}>{props.sending ? "ENVIANT..." : config.textBotoMatricular }</button>
        </div>

      </div>
    </div>)
  }

  const jumpInscripcio = () => 
  {
    if(!config.develop) return () => {}


    //setDadesPersonals({...dadesPersonals, "iddocument": "11111111H", "dataNaixement": "2014-01-01", "validat": true})

    setDadesPersonals({...dadesPersonals, "iddocument": "11111111H", dataNaixement: new Date(),  "validat": true})
    setDadesMediques({...dadesMediques, "validat": true})
    setDadesLaborals({...dadesLaborals, "validat": true})

    function delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    }

    delay(200).then(() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }));
  }



  return (
    <form action={config.enrollmentPostURL} method="POST" onSubmit={submitForm}>

      <div className="t-Body">

        <EnrolmentFormHeader />
            <EnrolmentFormBreadcrumb dadesPersonals={dadesPersonals}
                                     dadesMediques={dadesMediques}
                                     dadesLaborals={dadesLaborals}
                                     dadesEstudis={dadesEstudis}
                                     dadesAutoritzacions={dadesAutoritzacions}
                                     jumpInscripcio={jumpInscripcio}
                                     saltaDadesMediques={saltaDadesMediques}
                                     saltaDadesLaborals={saltaDadesLaborals}
               />

        <div className="row">
          <div className="col col-12 ">
            <div
              className="t-BreadcrumbRegion t-BreadcrumbRegion--showBreadcrumb t-BreadcrumbRegion--useBreadcrumbTitle">
              <div className="t-BreadcrumbRegion-body">

                <div className="t-BreadcrumbRegion-breadcrumb">
                  <ul className="t-Breadcrumb ">
                    <li className="t-Breadcrumb-item is-active">
                      <h1 className="t-Breadcrumb-label">Matrícula {enguany}/{anyVinent}</h1>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>


        { config.popupInicial && (<ModalPopup families={families}  isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} /> )}

        <div className="t-Body-content" id="t_Body_content">
          <div className="t-Body-main" style={{ marginTop: "0px" }}>
            {/*<div className="t-Body-title" id="t_Body_title" style={{ top: "40px" }}></div>*/}
            <div className="t-Region">


              <div className="t-Body-content">
                <div className="t-Region-bodyWrap">
                  <div className="t-Region-body">

                    {inscripcio === undefined && (
                      <React.Fragment>
                        <EnrolmentFormPersonalData dadesPersonals={dadesPersonals} handleDadesPersonals={handleChangeDadesPersonals}
                                                     dadesMediques={dadesMediques} handleDadesMediques={handleChangeDadesMediques}
                                                     dadesLaborals={dadesLaborals} handleDadesLaborals={handleChangeDadesLaborals}
                                                     families={families}
                                                   />

                        {dadesPersonals.validat && !saltaDadesMediques && (
                            <EnrolmentFormMedicalData dadesPersonals={dadesPersonals} handleDadesPersonals={handleChangeDadesPersonals}
                                                      dadesMediques={dadesMediques} handleDadesMediques={handleChangeDadesMediques} />
                            )}


                        {dadesPersonals.validat && dadesMediques.validat && !saltaDadesLaborals && (
                            <EnrolmentFormEmploymentData edat={dadesPersonals.edat} dadesLaborals={dadesLaborals} handleDadesLaborals={handleChangeDadesLaborals}/>
                            )}

                        {dadesPersonals.validat && dadesMediques.validat && dadesLaborals.validat && (
                          <React.Fragment>
                            <EnrolmentFormStudies dadesPersonals={dadesPersonals} 
                                                  dadesEstudis={dadesEstudis} handleDadesEstudis={handleChangeDadesEstudis} 
                                                  />

                        {dadesEstudis.validat && (
                            <EnrolmentFormAuthorizations dadesPersonals={dadesPersonals} 
                                                         dadesEstudis={dadesEstudis}
                                                         enguany={enguany} anyVinent={anyVinent} 
                                                         dadesAutoritzacions={dadesAutoritzacions} handleDadesAutoritzacions={handleChangeDadesAutoritzacions}
                                                         />)}


                        {dadesPersonals.validat &&
                        dadesMediques.validat && 
                        dadesLaborals.validat && 
                        dadesEstudis.validat && 
                        dadesAutoritzacions.validat && (

                          <BotoInscriure sending={sending} showText={true}/>
                            )}

                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )
                    }

                    { inscripcio?.response === "ok" && redirigirTPV && (
                      <div className="container inscripcioBlock">
                        <div className="inscripcioContingut col col-5">
                          <h2>
                            Inscripció realitzada correctament
                          </h2>
                          <div className="inscripcioText">
                            Redirigint a la passarel·la de pagament…
                          </div>
                        </div>
                      </div>
                    )
                    }

                    { inscripcio?.response === "ok" && !redirigirTPV && (
                      <div className="container inscripcioBlock">
                        <div className="inscripcioContingut col col-5">
                          <h2>
                            Inscripció realitzada correctament
                          </h2>
                          { config.pagamentTPV && (
                            <h3 className="inscripcioTPV">
                              Cal accedir a <br/><a href={ config.urlTPV+"?uuid=" + uuid + "&iddocument=" + dadesPersonals?.iddocument } target="_blank" rel="noreferrer">{config.urlTPV}</a>  <br/> per realitzar pagament i formalitzar la inscripció
                            </h3>
                           )}

                           { config.textInscripcioText &&  (
                          <div className="inscripcioText">
                            {config.textInscripcioText()}
                          </div>)}

                          <div className="inscripcioText">
                            El vostre número d'inscripció és el:
                          </div>
                          <div className="inscripcioNumero">{inscripcio?.id}</div>
                          <div className="inscripcioText">
                            Proporcioneu aquest número per a qualsevol tràmit en referència a aquesta inscripció.
                          </div>
                          <div className="inscripcioText">
                            Per a qualsevol dubte, contacteu a:<br/>
                              <ul>
                                <li>Telèfon <a href={'tel:+34' + config.phone.replace(/ /g, '')}>{config.phone}</a></li>
                                <li>A/e: <a href={config.email}>{config.email}</a></li>
                              </ul>
                          </div>
                        <p>
                          
                        </p>
                      </div>
                      </div>
                    )
                    }

                    {inscripcio?.response === "ko" && (
                      <div className="container inscripcioBlock">
                        <div className="inscripcioContingut col col-5">
                          <h2>
                            Error en la inscripció
                          </h2>
                          <div className="inscripcioText">
                            <small> {inscripcio.response.error} </small><br/>
                            Torneu-ho a provar passats uns minuts<br/>
                            <BotoInscriure sending={sending} showText={false} />
                          </div>
                          <div className="inscripcioText">
                            O contacteu amb:<br/>
                              <ul>
                                <li>Telèfon <a href={'tel:+34' + config.phone.replace(/ /g, '')}>{config.phone}</a></li>
                                <li>A/e: <a href={config.email}>{config.email}</a></li>
                              </ul>
                          </div>
                        <p>
                          
                        </p>
                      </div>
                      </div>
                    )
                    }

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </form>
  )
}